import axios from "axios";

export default axios.create({
  baseURL:
    process.env.REACT_APP_ENV === "production"
      ? process.env.REACT_APP_API_ENDPOINT_PRD
      : process.env.REACT_APP_API_ENDPOINT_DEV,
  responseType: "json",
});
